<template>
  <div class="view-inner">
    <h3 class="title">
      {{ $t('WalletConnect.register.pageheader') }}
    </h3>
    <h5 class="sub-title">
      {{ $t('WalletConnect.register.pagesub') }}
    </h5>
    
    <b-row align-v="center">
      <b-col 
        sm="12" 
        md="6" 
      >
        <validation-observer
          ref="registForm"
        >
          <b-form
            @submit.prevent="submit"
          >
            <!-- eth walelt -->
            <b-form-group>
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem1') }}</span>
              </label>
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem1')"
                vid="ethAddress"
                rules="required"
              >
                <b-input-group>
                  <b-form-input
                    id="ethAdrs"
                    v-model="formData.ethAddress"
                    :disabled="true"
                  />
                  <b-input-group-append>
                    <b-button 
                      variant="primary" 
                      @click="wc"
                    >
                      {{ $t('WalletConnect.register.formItem1handler') }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- chia address -->
            <!-- <b-form-group>
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem2') }}</span>
                <a 
                  class="handle color-primary" 
                  :href="helpLink"
                  target="blank_"
                >
                  <feather-icon 
                    icon="HelpCircleIcon" 
                    size="16"
                  />
                  <span>Help</span>
                </a>
              </label>
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem2')"
                vid="chiaAddress"
                rules="required"
              >
                <b-form-input
                  id="chiaAddress"
                  v-model="formData.chiaAddress"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group> -->

            <!-- Chia Launcher Id -->
            <b-form-group>
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem3') }}</span>
                <a 
                  class="handle color-primary" 
                  :href="helpLink"
                  target="blank_"
                >
                  <feather-icon 
                    icon="HelpCircleIcon" 
                    size="16"
                  />
                  <span>Help</span>
                </a>
              </label>
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem3')"
                vid="chiaLauncherId"
                rules="required"
              >
                <b-form-input
                  id="publicKey"
                  v-model="formData.chiaLauncherId"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- sign -->
            <b-form-group>
              
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem4') }}</span>
              </label>
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem4')"
                vid="chiaSign"
                rules="required"
              >
                <b-form-input
                  id="signature"
                  v-model="formData.chiaSignature"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>


            <!-- Country -->
            <b-form-group>
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem5') }}</span>
              </label>
              <!-- rules="oneOf:1,2,3" -->
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem5')"
                vid="country"
              >
                <b-form-select
                  id="contry"
                  v-model="formData.country"
                  :options="countryList"
                /> 
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <b-row>
                <b-col cols="6">
                  <!-- first name -->
                  <label slot="label">
                    <span>{{ $t('WalletConnect.register.formItem6') }}</span>
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('WalletConnect.register.formItem6')"
                    vid="fstname"
                    rules="required"
                  >
                    <b-form-input
                      id="FstName"
                      v-model="formData.firstName"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <!-- last name -->
                  <label slot="label">
                    <span>{{ $t('WalletConnect.register.formItem7') }}</span>
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('WalletConnect.register.formItem7')"
                    vid="lstname"
                    rules="required"
                  >
                    <b-form-input
                      id="LstName"
                      v-model="formData.lastName"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-form-group>


            <!-- phone -->
            <b-form-group>
              <b-row>
                <b-col cols="4">
                  <label slot="label">
                    <span>{{ $t('WalletConnect.register.formItem8') }}</span>
                  </label>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-button 
                        variant="outline-secondary"
                        :disabled="true"
                      >
                        +
                      </b-button>
                    </b-input-group-prepend>
                    <b-form-select
                      id="phonePrefix"
                      v-model="formData.phonePrefix"
                      :options="codeList"
                    />
                  </b-input-group>
                </b-col>
                <b-col cols="8">
                  <label slot="label">
                    &nbsp;
                  </label>
                  <!-- rules="required" -->
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('WalletConnect.register.formItem8')"
                    vid="phone"
                  >
                    <b-form-input
                      id="Phone"
                      v-model="formData.phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-form-group>

            <!-- Address -->
            <b-form-group>
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem9') }}</span>
              </label>
              <!-- rules="required" -->
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem9')"
                vid="address"
              >
                <b-form-input
                  id="address"
                  v-model="formData.address"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- city and state -->
            <b-form-group>
              <b-row>
                <b-col cols="6">
                  <!-- city -->
                  <label slot="label">
                    <span>{{ $t('WalletConnect.register.formItem10') }}</span>
                  </label>
                  <!-- rules="required" -->
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('WalletConnect.register.formItem10')"
                    vid="city"
                  >
                    <b-form-input
                      id="city"
                      v-model="formData.city"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <!-- state -->
                  <label slot="label">
                    <span>{{ $t('WalletConnect.register.formItem11') }}</span>
                  </label>
                  <!-- rules="required" -->
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('WalletConnect.register.formItem11')"
                    vid="state"
                  >
                    <b-form-input
                      id="state"
                      v-model="formData.state"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-form-group>

            <!-- zip -->
            <b-form-group>
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem12') }}</span>
              </label>
              <!-- rules="required" -->
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem12')"
                vid="zipcode"
              >
                <b-form-input
                  id="ZipCode"
                  v-model="formData.zipCode"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- email -->
            <b-form-group>
              <label slot="label">
                <span>{{ $t('WalletConnect.register.formItem13') }}</span>
              </label>
              <validation-provider
                #default="{ errors }"
                :name="$t('WalletConnect.register.formItem13')"
                vid="email"
                rules="required"
              >
                <b-form-input
                  id="email"
                  v-model="formData.email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <b-form-checkbox
                v-model="accepted"
                unchecked-value="not_accepted"
              >
                {{ $t('WalletConnect.register.formAccept') }}
              </b-form-checkbox>
            </b-form-group>

            <!-- :disabled="invalid" -->
            <b-overlay
              :show="isLoading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-block"
            >
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="isLoading"
              >
                {{ $t('WalletConnect.register.formButton') }}
              </b-button>
            </b-overlay>
          </b-form>
        </validation-observer>
      </b-col>
      <b-col 
        sm="12"
        md="6"
        class="r-part"
      >
        <img src="@/assets/images/walletconnect/content-r-1.png">
      </b-col>
    </b-row>
    <!-- #default="{invalid}" -->
    
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupPrepend,BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'

import walletAuth from '@/auth/wallet/auth'
import store from '@/store/index'
import countrys from '@core/utils/countrys'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

// import CountryDropdown from '@core/layouts/components/app-navbar/components/CountryDropdown.vue'
// import { indexOf } from 'postcss-rtl/lib/affected-props'
import {mapGetters} from 'vuex'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    // CountryDropdown
  },
  data() {
    return {
      helpLink: "https://docs.maxipool.net/maxipool/miners-1",
      accepted: false,
      countryList: countrys.map(item => item['en']),
      codeList: Array.from(new Set(countrys.map(item => item['code']).sort())),
      isLoading: false,
      formData: {
        "ethAddress": this.account,
        "ethAuthMsg": this.eth_sign || "",
        "ethSignature": this.auth_msg || "",
        "firstName": "",
        "lastName": "",
        "phonePrefix": countrys.map(item => item['code'])[0],
        "phone": "",
        "country": countrys.map(item => item['en'])[0],
        "city": "",
        "state": "",
        "address": "",
        "zipCode": "",
        "email": "",
        // "chiaAddress": "",
        // "chiaPublicKey": "",
        "chiaLauncherId": "",
        "chiaSignature": ""
      }
    }
  },
  computed: {
    ...mapGetters("wallet", {
      "account": "account",
      "eth_sign": "eth_sign",
      "auth_msg": "auth_msg",
    })
  },
  watch: {
    "formData.country" (n) {
        let idx = this.countryList.indexOf(n)
        // this.formData.phonePrefix = this.codeList[idx]
        this.formData.phonePrefix = countrys[idx]['code']
    },
  },
  mounted(){
    this.formData.ethAddress = this.account
    this.formData.ethAuthMsg = this.auth_msg
    this.formData.ethSignature = this.eth_sign
  },
  methods: {
    submit(){
      if (this.isLoading) return false

      this.$refs.registForm.validate().then(async validate => {
        if(!validate) return false

        if (!this.accepted) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              text: this.$t('WalletConnect.register.formTip'),
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          })
          return false
        }

        let params = {...this.formData}
        for (let i in params) {
          if(typeof(params[i]) !== 'string') {
            params[i] = String(params[i])
          }
        }

        let {ethAddress, ethAuthMsg, ethSignature} = this.formData
        this.isLoading = true
        try {
          let res = await walletAuth.service.register(params)
          walletAuth.service.login({ethAddress, ethAuthMsg, ethSignature})
            .then(account => {
              this.isLoading = false
              this.$router.replace({name: 'wc-account'})
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  icon: 'CheckIcon',
                  text: 'Regist successed!',
                },
              })
              this.$nextTick(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Welcome ${account.data.user.nickName}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: `${res.msg}`,
                  },
                })
              })

            })
        } catch (err) {
          this.isLoading = false
        }
      })
    },
    async wc(){
      await this.$metaMaskUtils.initlization()
      await this.$metaMaskUtils.ethSign()
      this.formData.ethAddress = this.account
      this.formData.ethAuthMsg = this.auth_msg
      this.formData.ethSignature = this.eth_sign
    }
  }
}
</script>


<style scoped>
.title {
  font-size: 27px;
  margin-bottom: 10px;
}

.sub-title {
  font-size: 18px;
  margin-bottom: 60px;
  color: #666666;
  font-weight: 300;
}

.view-inner {
  padding-left: 15px;
  padding-right: 15px;
}

.r-part {
  padding-left: 60px;
}

.r-part img {
  width: 462px;
  display: block;
}

.btn[type=submit] {
  font-size: 18px;
}

.btn-outline-secondary {
  border-color: rgb(206, 212, 218) !important;
}


.col-form-label label {
  width: 100%;
  line-height: 16px;
}

.col-form-label .handle{
  float: right;
  cursor: pointer;
  color: #03b000;
}

.col-form-label .handle svg {
  vertical-align: middle;
  margin-right: 2px;
}

.col-form-label .handle span {
  font-size: 12px;
  vertical-align: middle;
}
</style>